import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturou erro:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Ocorreu um erro inesperado</h1>
          <p style={{ color: '#555', marginBottom: '1rem' }}>Tente atualizar a página. Se persistir, contate o suporte.</p>
          {process.env.NODE_ENV !== 'production' && (
            <pre style={{ textAlign: 'left', background: '#f8f8f8', padding: '1rem', overflow: 'auto', fontSize: '0.75rem' }}>
              {String(this.state.error)}
            </pre>
          )}
          <button onClick={() => window.location.reload()} style={{ background:'#3b82f6', color:'#fff', padding:'0.5rem 1rem', borderRadius:4 }}>Recarregar</button>
        </div>
      );
    }
    return this.props.children;
  }
}
